import { createContext } from "react";

const WhiteLabelDomainContext = createContext({});

export default WhiteLabelDomainContext;
